import { useStores } from '@storage/hooks/use-stores.hook'
import { useTranslate } from '@tolgee/react'
import { Header } from '@tom-ui/ui'
import { useEffect } from 'react'
import GeneralCargoInventoryTableNew from './components/GeneralCargoInventoryTableNew'
import GeneralCargoStockOccupancyDamageDialog from './components/GeneralCargoStockOccupancyDamageDialog'

const GeneralCargoInventory = () => {
  const { t } = useTranslate()
  const { generalCargoInventoryUIStore } = useStores()

  useEffect(() => {
    generalCargoInventoryUIStore.setSearchQuery('')

    return () => {
      generalCargoInventoryUIStore.setSearchQuery('')
    }
  }, [generalCargoInventoryUIStore])

  return (
    <>
      <Header
        title={t('generalCargoInventory', 'Inventory')}
        searchInputLabel={t(
          'generalCargoInventorySearch',
          'Search for customer, commodity, lot number or unit ID',
        )}
        onSearchFieldChange={value => generalCargoInventoryUIStore.setSearchQuery(value)}
        displaySearchIcon
        enableSearchField
      />

      <GeneralCargoInventoryTableNew />
      <GeneralCargoStockOccupancyDamageDialog />
    </>
  )
}

export default GeneralCargoInventory
